export const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const dateFormatter = (
  dateInput: Date | string,
  view: 'short' | 'long' | Intl.DateTimeFormatOptions = 'short',
  includeTime: boolean = false
): string => {
  let date: Date;
  if (typeof dateInput === 'string') {
    date = new Date(dateInput);
  } else {
    date = dateInput;
  }

  let options: Intl.DateTimeFormatOptions;

  if (view === 'short') {
    options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      ...(includeTime && {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }),
    };
  } else if (view === 'long') {
    options = {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      weekday: 'long',
      ...(includeTime && {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }),
    };
  } else {
    options = {
      ...view,
      ...(includeTime && {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      }),
    };
  }

  return new Intl.DateTimeFormat('en-US', options).format(date);
};
